export default __webpack_public_path__ + "static/media/Mark-6-Suit-00.5bc6d8bf.jpg";